import { render, staticRenderFns } from "./NotesLandingMenu.vue?vue&type=template&id=5d9517e8&scoped=true&"
import script from "@/scripts/Notes/NotesLanding/components/NotesLandingMenu.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NotesLanding/components/NotesLandingMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9517e8",
  null
  
)

export default component.exports